import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { TaskStatus } from '../models/task-status.model';

@Injectable({
  providedIn: 'root'
})
export class TaskStatusService {

  constructor(private httpClient: HttpClient) { }

  getTaskStatus() : Observable<TaskStatus[]> {
    return this.httpClient.get<TaskStatus[]>('assets/components/task-status/task-status.json').pipe(
      map(data => data)
    );
  }
}
